import { useDisclosure } from '@mantine/hooks';
import { useMemo } from 'react';
import { MultiSelectionToggleGlobal } from 'src/components/common/MultiSelect/Toggle/MultiSelectionToggleGlobal';
import { InventoryEventFilterDrawer } from 'src/components/Listings/InventoryEventPage/InventoryEventPageRework/Mobile/SortAndFilter/InventoryEventFilterDrawer';
import { InventoryEventSortingContent } from 'src/components/Listings/InventoryEventPage/InventoryEventPageRework/Mobile/SortAndFilter/InventoryEventSortingContent';
import { ListingSearchBox } from 'src/components/Listings/ListingFilterBar/ListingSearchBox';
import { useMobileDrawerContext } from 'src/contexts/MobileDrawerContext';
import { useMobileListingDrawerContext } from 'src/contexts/MobileListingDrawerContext/MobileListingDrawerContext';
import { useMobileInventorySortAndFilterContext } from 'src/contexts/MobileSortAndFilterContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { BadgedIcon } from 'src/core/ui/BadgedIcon/BadgedIcon';
import { SortIcon } from 'src/svgs/SortIcon';
import { FilterIcon } from 'src/svgs/Viagogo';

import * as styles from './EventFilterBar.css';

export const EventFilterBar = () => {
  const { onSelectListing } = useMobileListingDrawerContext();
  const { openWithContent } = useMobileDrawerContext();
  const { hasSortingChanged, hasFilterApplied } =
    useMobileInventorySortAndFilterContext();

  const { selectionMode } = useMultiSelectionContext();
  const [show, { open, close }] = useDisclosure(false);

  const isInBulk = useMemo(
    () => Boolean(selectionMode?.mode),
    [selectionMode?.mode]
  );

  return (
    <>
      <Stack
        alignItems="center"
        gap="m"
        className={styles.eventFilterContainer}
      >
        <div style={{ display: 'flex', flex: `1 1 auto` }}>
          <ListingSearchBox
            minWidth={'unset'}
            onListingFound={onSelectListing}
          />
        </div>
        <div
          className={styles.eventFilterButton}
          onClick={() =>
            !isInBulk &&
            openWithContent(<InventoryEventSortingContent />, { size: '75%' })
          }
        >
          <BadgedIcon
            icon={
              <SortIcon
                size={vars.iconSize.m}
                fill={vars.color.surfaceInverted}
              />
            }
            withBadge={hasSortingChanged}
          />
        </div>
        <div
          className={styles.eventFilterButton}
          onClick={() => !isInBulk && open()}
        >
          <BadgedIcon
            icon={
              <FilterIcon
                size={vars.iconSize.m}
                fill={vars.color.surfaceInverted}
              />
            }
            withBadge={hasFilterApplied}
          />
        </div>
        <MultiSelectionToggleGlobal variant="button" />
      </Stack>
      <InventoryEventFilterDrawer show={show} onClose={close} />
    </>
  );
};
